import * as React from 'react';

import CertificateSigning56 from './CertificateSigning56';

export const certificateSigning56 = () => <CertificateSigning56 />;

export default {
    title: 'Illustration/CertificateSigning56',
    component: CertificateSigning56,
    parameters: {
        notes: "`import CertificateSigning56 from 'box-ui-elements/es/illustration/CertificateSigning56';`",
    },
};
